export class HandledError extends Error {
  constructor() {
    super('Handled error')
  }
}
